/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */




export const ProcessStatusDto = {
    Created: 'CREATED',
    InProgress: 'IN_PROGRESS',
    Finished: 'FINISHED',
    Canceled: 'CANCELED',
} as const;

export type ProcessStatusDto = typeof ProcessStatusDto[keyof typeof ProcessStatusDto];



